export function initFlickitySlider(slider, alignment = 'center') {
  const flkty = new Flickity(slider, {
    cellAlign: alignment,
    contain: true,
    wrapAround: false,
    pageDots: false,
    prevNextButtons: true
  });

  const items = slider.querySelectorAll('.wp-block-post, iframe'); // fixed selector

  if (items.length) {
    let maxHeight = 0;

    items.forEach(item => {
      item.style.minHeight = '';
      const itemHeight = item.offsetHeight;
      if (itemHeight > maxHeight) {
        maxHeight = itemHeight;
      }
    });

    items.forEach(item => {
      item.style.minHeight = maxHeight + 'px';
    });
  }

  const prevBtn = slider.querySelector('.flickity-button.previous');
  const nextBtn = slider.querySelector('.flickity-button.next');

  if (prevBtn && nextBtn) {
    const wrapper = document.createElement('div');
    wrapper.className = 'site__wrapper';

    slider.insertBefore(wrapper, prevBtn);
    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);
  }
}